<template>
  <b-row align-h="center" ref="configuratorTop">
    <b-col sm="10">
      <div class="step-header">
        <span class="step-number badge badge-pill badge-dark">{{ step }}</span>
        <span class="step-title">{{ title }}</span>
      </div>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    name: 'ConfiguratorStepTitle',
    props: {
      step: {
        type: Number,
        required: true
      },
      title: {
        type: String,
        required: true
      }
    }
  }
</script>